import {Application} from "./application";
import {AccountsApi} from "./api/accounts";
import * as ko from "knockout";

export default class AccountManager {
    application: Application;
    accounts: AccountsApi;
    subscriptionExpired: KnockoutObservable<boolean>;
    
    constructor(private app: Application) {
        this.application = app;
        this.accounts = app.apiManager.accounts;
        this.subscriptionExpired = ko.observable(false);
        this.recurrentPaymentCheck();        
        setInterval(this.recurrentPaymentCheck.bind(this), 10000);     
    }
    
    recurrentPaymentCheck():void{
        this.accounts.check().then((data) => {
            if (data){                
                this.subscriptionExpired(data.paymentRequired);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/services/accountManager.ts